import {messagesService} from "@dv5/api"

interface UpdateScrollPosition {
    canvasId: string
    scrollLeft: number
    scrollTop: number
}

class CanvasScrollPositionService {

    updateScrollPosition(canvasId: string, left: number, top: number) {
        messagesService.send<UpdateScrollPosition>('canvas.update-scroll-position', {
            canvasId: canvasId,
            scrollLeft: Math.round(left),
            scrollTop: Math.round(top),
        })
    }
}

export const canvasScrollPositionService = new CanvasScrollPositionService()
